import Upload from './Upload'
import UploadWithCrop from './UploadWithCrop'

export { UploadWithCrop }
export default Upload
